import { useLocalStorageState } from "src/hooks/use_local_storage_state"

import { PREFIX, SELECTED_DEFAULT_PRINTER_ID } from "../storage_keys"

export const useSelectedDefaultPrinterId = () =>
  useLocalStorageState(PREFIX, SELECTED_DEFAULT_PRINTER_ID)
